import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, convertUtcToLocalDate } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelineTerminateCircuitModel
    //action
    , resetWirelineTerminateCircuitForm
    , setSubscriptionDetails
    , setRequestSelectedData
    , setFormSubmitted
    , setResetLoading
    , setResetApprover
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-terminate-circuit.settings';
import { onSelectedApprover } from './new-circuit/new-circuit-subscription.reducer';

export const terminateCircuitModelAInitialState = wirelineTerminateCircuitModel;

const defaultState = () => ({
    subscription: {}
    , formSubmitted: false
    , isResetLoading: false
    , isResetApprover: false
});

const initialState = defaultState();

export const wirelineTerminateCircuitActions = {
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;

        if (value === '') {
            resetForm(dispatch, state);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && obj.CircuitId != wirelineTerminateCircuitFormA.circuitId) {
                    resetForm(dispatch, state);
                    dispatch(actions.reset('wirelineTerminateCircuitFormA.circuitCode'));
                    dispatch(actions.reset('wirelineTerminateCircuitFormA.circuitId'));
                    dispatch(actions.reset('wirelineTerminateCircuitFormA.vendor'));
                    dispatch(actions.reset('wirelineTerminateCircuitFormA.plan'));
                    dispatch(actions.reset('wirelineTerminateCircuitFormA.terminateDate'));
                    dispatch(actions.change('wirelineTerminateCircuitFormA.circuitCode', value));
                    dispatch(actions.change('wirelineTerminateCircuitFormA.circuitId', obj.CircuitId));
                    dispatch(actions.change('wirelineTerminateCircuitFormA.vendor', obj.Vendor));
                    dispatch(actions.change('wirelineTerminateCircuitFormA.plan', obj.PlanName));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                }
            }           
        }
    },
    
    setRequestSelectedData: () => (dispatch, state) => {
        const { requestData } = state().requestDetail;
        const { subscriptionList } = state().createRequest;
        if (requestData === '' || requestData === undefined) {
            dispatch(actions.reset('wirelineTerminateCircuitFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else { 
            dispatch(actions.reset('wirelineTerminateCircuitFormA'));
            dispatch(actions.change('wirelineTerminateCircuitFormA.circuitCode', requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelineTerminateCircuitFormA.circuitId', requestData.Circuit.CircuitId));
            dispatch(actions.change('wirelineTerminateCircuitFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
            dispatch(actions.change('wirelineTerminateCircuitFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation)); 
            dispatch(actions.change('wirelineTerminateCircuitFormA.terminateDate',  !requestData.Order.OrderDisconnectDate == false ? new Date(convertUtcToLocalDate(requestData.Order.OrderDisconnectDate)) : ""));
            dispatch(actions.change('wirelineTerminateCircuitFormA.vendor',  requestData.Subscription.VendorName));
            dispatch(actions.change('wirelineTerminateCircuitFormA.plan',requestData.Subscription.Plan));
            dispatch(actions.change('wirelineTerminateCircuitFormA.wireLineApproverId',requestData.WireLineApprover.EmployeeId));
            dispatch(actions.change('wirelineTerminateCircuitFormA.employeeEmail',requestData.WireLineApprover.Name));
            dispatch(onSelectedApprover(requestData.WireLineApprover.Name, requestData.WireLineApprover.EmployeeId))
            dispatch({ type: setResetApprover, data: false });
            var circuitCodePropName = 'CircuitCode';
            var subscription = subscriptionList ? subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode) : 0;
            dispatch({ type: setSubscriptionDetails, data: subscription });           
        }
    }
    
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineTerminateCircuitFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineTerminateCircuitFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''));
            dispatch({ type: setResetApprover, data: true });
        } else {
            const obj = objects?.find(o => o[propsName] === value);

            if (obj != null) {
                if (parseInt(obj.EmployeeId) !== parseInt(wirelineTerminateCircuitFormA.wireLineApproverId)) {
                    dispatch(actions.change('wirelineTerminateCircuitFormA.employeeEmail', value));
                    dispatch(actions.change('wirelineTerminateCircuitFormA.wireLineApproverId', obj.EmployeeId));
                }
                dispatch(onSelectedApprover(value, obj.EmployeeId));
                setTimeout(function () {
                    dispatch({ type: setResetApprover, data: false });
                }, 5)

            }
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;
        const { subscription } = state().wirelineTerminateCircuitRequest;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { requestData } = state().requestDetail;
        let userData = getUserData();
        var vendorDetailId = subscription.VendorDetailId === undefined ? 
                subscription && subscription.length > 0 ? subscription[0].VendorDetailId : 0 : subscription.VendorDetailId; 

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        let wirelineTerminateRequest = {
            ...wirelineTerminateCircuitFormA
            , requestInBehalfId: userData.requestInBehalfId
            , terminateDate: date
            , VendorDetailId: vendorDetailId
        }
        if (isUpdateRequest) {
            wirelineTerminateRequest = {
                ...wirelineTerminateRequest,
                OrderInfoId: requestData.OrderInfoId
            }
        }
        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , IsAmending: isUpdateRequest
            , wirelineTerminateRequest: wirelineTerminateRequest
            , OrderId: isUpdateRequest ? requestData.Order.OrderId : 0
            , CircuitId: isUpdateRequest ? requestData.CircuitId : 0
            , CircuitOrderId: isUpdateRequest ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isUpdateRequest ? requestData.OrderHistoryId : 0
            , ChangeRequestModel: {
                ...userData
                , ...wirelineTerminateCircuitFormA
                , CircuitId: wirelineTerminateCircuitFormA.circuitCode ? wirelineTerminateCircuitFormA.circuitId : 0
                , BusinessJustification: wirelineTerminateCircuitFormA.businessJustification
                , AdditionalInformation: wirelineTerminateCircuitFormA.additionalInformation
                , RequestTypeId: requestTypeId
                , NoEmail: true
            }
        }

        

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetApprover: () => (dispatch, state) => {
        dispatch({ type: setResetApprover, data: false });
    }
    , resetWirelineTerminateCircuitForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {
        resetForm(dispatch, state, isResetRequestOnBehalf);
    }
}

function resetForm(dispatch, state, isResetRequestOnBehalf = false) {
        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelineTerminateCircuitFormA.circuitCode'));
            dispatch(actions.reset('wirelineTerminateCircuitFormA.circuitId'));
            dispatch(actions.reset('wirelineTerminateCircuitFormA.employeeEmail'));
            dispatch(actions.reset('wirelineTerminateCircuitFormA.wireLineApproverId'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelineTerminateCircuitFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5)
        }
    dispatch(actions.reset('wirelineTerminateCircuitFormA'));
    dispatch({ type: setFormSubmitted, data: false });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case  setRequestSelectedData:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        case setResetApprover:
            return {
                ...state
                , isResetApprover: action.data
            }
        default: return state;
    }
}